<template>
<div class="container-fluid">
  <div class="row">
    <div class="product_items">
    <h1>{{ this.products.productGroups.filter(g => g.slug === this.groupSlug)[0].productCategories.filter(c => c.slug === this.categorySlug)[0].description }}</h1>
    <template v-for="ProductItem in products.productGroups.filter(g => g.slug === groupSlug)[0].productCategories.filter(c => c.slug === categorySlug)[0].products">
      <product-item-details :product="ProductItem" v-bind:key="ProductItem.productId" :smallimages="false" :groupSlug="groupSlug" :categorySlug="categorySlug"></product-item-details>
    </template>
    </div>
  </div>
</div>
</template>

<script>
import ProductItemDetails from './ProductItemDetails';

export default {
  name: 'product-items',
  props: ['groupSlug', 'categorySlug'],
  created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },
  computed: {
    products() {
      return this.$store.getters.allProducts;
    },
  },
  components: {
    'product-item-details': ProductItemDetails,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/ProductItems.vue